import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { obtenerClientes } from '../../services/clienteService';
// Eliminar: import { obtenerTodosLosCasos } from '../../services/casoService';
import AdminLayout from '../../components/layout/AdminLayout';
import './DashboardAdmin.css';

const DashboardAdmin = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    clientes: 0,
    casosActivos: 0
  });
  const [ultimosClientes, setUltimosClientes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    cargarDatos();
  }, [user, navigate]);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      const clientesData = await obtenerClientes();
      setUltimosClientes(clientesData.slice(0, 5));
      setStats({ 
        clientes: clientesData.length, 
        casosActivos: 0 
      });
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Cargando dashboard...</div>;

  return (
    <AdminLayout>
      <div className="dashboard-admin">
        <div className="dashboard-header">
          <h1>Panel de Gestion</h1>
          <p>Bienvenido, {user?.displayName}</p>
        </div>
        
        <div className="dashboard-stats">
          <div className="stat-card">
            <div className="stat-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 12V8H4V12M20 12L12 18L4 12M20 12V16H4V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="stat-info">
              <h3>Casos Activos</h3>
              <p className="stat-number">{stats.casosActivos}</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="stat-info">
              <h3>Clientes</h3>
              <p className="stat-number">{stats.clientes}</p>
            </div>
          </div>
        </div>

        <div className="dashboard-grid">
          <div className="dashboard-card">
            <h2>Acciones Rapidas</h2>
            <div className="quick-actions">
              <button onClick={() => navigate('/clientes')} className="quick-action-btn">
                <span className="action-icon">+</span>
                <span>Nuevo Cliente</span>
              </button>
              <button onClick={() => navigate('/casos')} className="quick-action-btn">
                <span className="action-icon">+</span>
                <span>Nuevo Caso</span>
              </button>
              <button onClick={() => navigate('/admin/articulos')} className="quick-action-btn">
                <span className="action-icon">+</span>
                <span>Nuevo Articulo</span>
              </button>
            </div>
          </div>
          
          <div className="dashboard-card">
            <h2>Ultimos Clientes</h2>
            {ultimosClientes.length === 0 ? (
              <p className="empty-state">No hay clientes registrados</p>
            ) : (
              <div className="clientes-lista">
                {ultimosClientes.map(c => (
                  <div key={c.id} className="cliente-item">
                    <div className="cliente-info-item">
                      <span className="cliente-nombre">{c.nombre}</span>
                      <span className="cliente-fecha">
                        {c.fechaRegistro?.toLocaleDateString()}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <button 
              onClick={() => navigate('/clientes')} 
              className="btn-ver-todos"
            >
              <span>Ver todos los clientes</span>
              <svg className="btn-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default DashboardAdmin;